import { createRoot } from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';
import { client } from 'modules/Apollo/client';
import App from './App';
import { APP_VERSION, APP_BUILD } from 'config/constants';
import { env } from 'config/env';
import localforage from 'localforage';
import { CurrentUserProvider } from 'hooks/useCurrentUser';
import { telemetryContextFor } from 'modules/Apollo/types';
import './appStyles';

window.onerror = () => {
  // If an unhandled exception occurs, let's clear the persistent
  // Apollo cache so that we can start fresh next time.
  localforage.clear();
};

const bold = 'font-weight: bold';
const monospace = 'font-family: monospace';

// eslint-disable-next-line no-console
console.info(
  `🚀 %cSirona Medical Frontend - Version %c%s %cBuild %c%s, %cDeploy Env %c%s, %cE2E Mode %c%s`,
  bold,
  monospace,
  APP_VERSION || 'N/A',
  bold,
  monospace,
  APP_BUILD || 'N/A',
  bold,
  monospace,
  env.DEPLOY_ENV ?? 'N/A',
  bold,
  monospace,
  env.E2E_TEST ?? 'N/A'
);

function RootApp() {
  return (
    <ApolloProvider client={client}>
      {/* TODO: Return StrictMode to the root once Apollo Client no longer leaves a discarded
          ObservableQuery when query owners are double-rendered. Until then, keep the single
          CurrentUser query owner outside; App remains fully strict. */}
      <CurrentUserProvider
        queryOptions={{
          context: CURRENT_USER_QUERY_CONTEXT,
          fetchPolicy: 'cache-and-network',
          nextFetchPolicy: 'cache-first',
        }}
      >
        <App />
      </CurrentUserProvider>
    </ApolloProvider>
  );
}

RootApp.displayName = 'RootApp';

const CURRENT_USER_TELEMETRY_CONTEXT = telemetryContextFor(RootApp);
const CURRENT_USER_QUERY_CONTEXT = {
  ...CURRENT_USER_TELEMETRY_CONTEXT,
  telemetry: {
    ...CURRENT_USER_TELEMETRY_CONTEXT.telemetry,
    fetchPolicy: 'cache-and-network',
  },
};

const rootElement = document.getElementById('root');

if (rootElement == null) {
  throw new Error('Could not find root element');
}

const root = createRoot(rootElement);
root.render(<RootApp />);
